import { INITIAL_STATE, PROGRESS_STATE } from '@/stateSteps'

const baseState = {
  steps: {
    address: INITIAL_STATE,
    currentStep: '',
    payment: INITIAL_STATE,
    personalData: PROGRESS_STATE,
    sendQuotation: INITIAL_STATE,
    termsAndConditions: PROGRESS_STATE
  },
  validatedSteps: {
    personalData: false,
    address: false
  },
  product: {
    recurrent: false,
    name: null,
    infoInsurance: null,
    isRenovation: false,
    lead: { uuid: '' },
    warningBox: {
      enable: false
    }
  },
  plan: {
    default: {
      completePrice: null
    },
    parcelasPrecos: null,
    precoTotal: null,
    promo: {
      completePrice: null
    },
    promoCode: {
      applied: false,
      code: null,
      error: null
    }
  },
  personalData: {
    uuid: '',
    name: '',
    birthday: '',
    cpf: '',
    cellphone: '',
    email: '',
    checkEmail: '',
    gender: '',
    isLoadingUserData: false
  },
  address: {
    zipcode: '',
    streetName: '',
    streetNumber: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: ''
  },
  promoCode: {
    activated: false,
    asyncPending: false,
    commission: 0,
    valid: null
  },
  payment: {
    token: undefined,
    asyncPending: false,
    methodsOptions: [],
    brand: '',
    typePayment: '',
    numberCard: '',
    lastCardNumbers: '',
    nameCard: '',
    validateCard: '',
    securityCode: '',
    cpfCard: '',
    parcels: '',
    campaign: {},
    paymentMethodData: {},
    installments: {
      ALELO: null,
      CREDIT_CARD: null,
      SCHEDULED_DEBIT: null,
      VIRTUAL_DEBIT_CAIXA: null
    },
    acceptedConditions: [],
    isActiveVoucher: false,
    isPromoFirstInstallment: false
  },
  isEmployee: false,
  isOperator: false
}

const initialState = JSON.parse(JSON.stringify(baseState))

function initialStateByModule (module) {
  return baseState[module]
}

export { initialState, initialStateByModule }
